import React from 'react';
import {
    ListItem,
    ListItemIcon,
    ListItemText,
    Checkbox,
    Typography,
    Divider
} from '@mui/material';

interface SelectAllHeaderProps {
    totalCount: number;
    selectedCount: number;
    onToggle: () => void;
}

export const SelectAllHeader: React.FC<SelectAllHeaderProps> = ({
    totalCount,
    selectedCount,
    onToggle
}) => {
    return (
        <>
            <ListItem
                onClick={onToggle}
                sx={{
                    cursor: 'pointer',
                    bgcolor: 'action.hover',
                    '&:hover': { bgcolor: 'action.selected' }
                }}
            >
                <ListItemIcon>
                    <Checkbox
                        checked={selectedCount === totalCount}
                        indeterminate={selectedCount > 0 && selectedCount < totalCount}
                        onClick={(e) => e.stopPropagation()}
                        onChange={onToggle}
                    />
                </ListItemIcon>
                <ListItemText
                    primary={
                        <Typography variant="subtitle2" fontWeight="bold">
                            Select All ({totalCount} centers)
                        </Typography>
                    }
                />
            </ListItem>
            <Divider />
        </>
    );
};
